// src/hooks/usePageTracking.ts
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { supabase } from '../lib/supabaseClient';

export const usePageTracking = () => {
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;

    const logPageVisit = async () => {
      // Temp user ve custom auth kontrolü
      const tempSession = localStorage.getItem('temp_user_session');
      const customAuth = localStorage.getItem('custom_auth_token');
      if (tempSession || customAuth) {
        return;
      }

      try {
        // Safe insert with conflict resolution
        const { error } = await supabase.rpc('safe_insert_activity_log', {
          p_user_id: user.id,
          p_action: 'page_visit',
          p_details: {
            page: location.pathname,
            search: location.search,
            timestamp: new Date().toISOString()
          },
          p_ip_address: null,
          p_user_agent: navigator.userAgent
        });
        
        if (error && error.code !== '23505') {
          console.warn('Page visit logging failed:', error.code);
        }
      } catch (error) {
        // Fallback to direct insert if RPC fails
        try {
          await supabase.from('activity_logs').insert({
            user_id: user.id,
            action: 'page_visit',
            details: {
              page: location.pathname,
              search: location.search,
              timestamp: new Date().toISOString()
            },
            ip_address: null,
            user_agent: navigator.userAgent
          });
        } catch (fallbackError) {
          // Sessizce logla, hata verme
          console.warn('Page visit logging failed (temp user?):', fallbackError);
        }
      }
    };

    logPageVisit();
  }, [location.pathname, user]);
};
